module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white-background-wrap"
  }, [_c('div', {
    staticClass: "social"
  }, [_c('h2', {
    staticClass: "section-header"
  }, [_vm._v("Social Media")]), _vm._v(" "), _c('p', [_vm._v("Check my social media links, follow me to stay updated")]), _vm._v(" "), _c('a', {
    staticClass: "link-wrap",
    attrs: {
      "href": "https://twitter.com/LowcoTV",
      "title": "Twitter",
      "target": "_blank",
      "rel": "noopener",
      "aria-label": _vm.twitterCount + ' twitter followers'
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "twitter",
      "scale": _vm.iconSize + 0.25
    }
  }), _vm._v(" "), _c('label', [_vm._v("Twitter")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.twitterCount) + " followers")])], 1), _vm._v(" "), _c('a', {
    staticClass: "link-wrap",
    attrs: {
      "href": "https://discord.gg/Lowco",
      "title": "Discord",
      "target": "_blank",
      "rel": "noopener",
      "aria-label": _vm.discordCount + ' discord members'
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "discord",
      "scale": _vm.iconSize
    }
  }), _vm._v(" "), _c('label', [_vm._v("Discord")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.discordCount) + " members")])], 1), _vm._v(" "), _c('a', {
    staticClass: "link-wrap",
    attrs: {
      "href": "https://www.youtube.com/user/Lowco2525",
      "title": "Youtube",
      "target": "_blank",
      "rel": "noopener",
      "aria-label": _vm.youtubeCount + ' Lowco Games youtube subscribers'
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "youtube-play",
      "scale": _vm.iconSize + 0.25
    }
  }), _vm._v(" "), _c('label', [_vm._v("LowcoGames")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.youtubeCount) + " subscribers")])], 1), _vm._v(" "), _c('a', {
    staticClass: "link-wrap",
    attrs: {
      "href": "https://www.youtube.com/channel/UC3GZtOeb7Pe2HVYYPk6ilnA",
      "title": "Youtube",
      "target": "_blank",
      "rel": "noopener",
      "aria-label": _vm.youtube2Count + ' Lowco youtube viewers'
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "youtube-play",
      "scale": _vm.iconSize + 0.25
    }
  }), _vm._v(" "), _c('label', [_vm._v("Lowco")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.youtube2Count) + " subscribers")])], 1), _vm._v(" "), _c('a', {
    staticClass: "link-wrap",
    attrs: {
      "href": "https://www.instagram.com/lowco2525/",
      "title": "Instagram",
      "target": "_blank",
      "rel": "noopener",
      "aria-label": _vm.instagramCount + ' instagram followers'
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "instagram",
      "scale": _vm.iconSize
    }
  }), _vm._v(" "), _c('label', [_vm._v("Lowco2525")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.instagramCount) + " followers")])], 1), _vm._v(" "), _c('a', {
    staticClass: "link-wrap",
    attrs: {
      "href": "https://www.instagram.com/lowcotv/",
      "title": "Instagram",
      "target": "_blank",
      "rel": "noopener",
      "aria-label": _vm.instagram2Count + ' instagram followers'
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "instagram",
      "scale": _vm.iconSize
    }
  }), _vm._v(" "), _c('label', [_vm._v("LowcoTV")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.instagram2Count) + " followers")])], 1), _vm._v(" "), _c('a', {
    staticClass: "link-wrap",
    attrs: {
      "href": "https://www.twitch.tv/lowco",
      "title": "Twitch",
      "target": "_blank",
      "rel": "noopener",
      "aria-label": _vm.twitchCount + ' twitch followers'
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "twitch",
      "scale": _vm.iconSize
    }
  }), _vm._v(" "), _c('label', [_vm._v("Twitch")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.twitchCount) + " followers")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c2855b0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Social.vue
// module id = 1161
// module chunks = 2